import React, { useState, useEffect } from 'react';

const Testimonials = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const testimonials = [
    { src: '/images/feed1.jpg', alt: 'Depoimento de Aluno 1' },
    { src: '/images/feed2.jpg', alt: 'Depoimento de Aluno 2' },
    { src: '/images/feed3.jpg', alt: 'Depoimento de Aluno 3' },
    { src: '/images/feed4.jpg', alt: 'Depoimento de Aluno 4' },
    { src: '/images/feed5.jpg', alt: 'Depoimento de Aluno 5' },
    { src: '/images/feed6.jpg', alt: 'Depoimento de Aluno 6' },
  ];

  // Carrossel automático
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 4000); // Muda a cada 4 segundos

    return () => clearInterval(timer);
  }, [testimonials.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrevious = () => {
    setCurrentSlide((prev) => 
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  return (
    <section id="depoimentos" className="py-20 bg-gradient-to-br from-orange-50 to-orange-100">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-bold text-center text-gray-800 mb-4">
          Depoimentos dos Alunos
        </h2>
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          Veja o que nossos alunos estão dizendo sobre o curso
        </p>

        {/* Carrossel */}
        <div className="max-w-4xl mx-auto relative">
          <div className="relative overflow-hidden rounded-2xl shadow-2xl bg-white">
            {/* Imagens do Carrossel */}
            <div 
              className="flex transition-transform duration-500 ease-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {testimonials.map((testimonial, index) => (
                <div key={index} className="min-w-full">
                  <img 
                    src={testimonial.src} 
                    alt={testimonial.alt}
                    className="w-full h-auto object-contain max-h-[600px]"
                  />
                </div>
              ))}
            </div>

            {/* Botão Anterior */}
            <button
              onClick={goToPrevious}
              className="absolute left-4 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-3 rounded-full transition-all duration-200 hover:scale-110"
              aria-label="Depoimento anterior"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>

            {/* Botão Próximo */}
            <button
              onClick={goToNext}
              className="absolute right-4 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-3 rounded-full transition-all duration-200 hover:scale-110"
              aria-label="Próximo depoimento"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>

          {/* Indicadores (dots) */}
          <div className="flex justify-center mt-6 gap-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`transition-all duration-300 rounded-full ${
                  currentSlide === index 
                    ? 'bg-orange-500 w-8 h-3' 
                    : 'bg-gray-300 hover:bg-gray-400 w-3 h-3'
                }`}
                aria-label={`Ir para depoimento ${index + 1}`}
              />
            ))}
          </div>

          {/* Contador */}
          <div className="text-center mt-4 text-gray-600 font-medium">
            {currentSlide + 1} / {testimonials.length}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
